import {
    useStyles,
    useAppDisplayModeContext,
    Label,
    Button,
    pxToRem,
} from '@archipro-design/aria';

import * as S from './Awards.style';

import { AwardRowFullMobile } from './AwardRowFull.mobile';
import { useLoaderData, useSearchParams } from 'react-router';
import { AwardRowFull } from './AwardRowFull';
import { AwardRowSingleMobile } from './AwardRowSingle.mobile';
import type { InfoPageLoaderData } from '@modules/professional/api/info-page-loader.server';
import PageSection from '@modules/professional/component/page-layout/PageSection';

export const AWARDS_PER_PAGE_DESKTOP = 10;
export const AWARDS_PER_PAGE_MOBILE = 4;

//change this when merged properly
export interface AwardItem {
    YearAwarded?: string;
    AwardingInstitutionTitle?: string;
    Title: string;
}

interface AwardPageInfo {
    hasNextPage?: boolean | null;
    hasPreviousPage?: boolean | null;
    totalCount: number;
    currentPage?: number;
}

export const Award: React.FC<{ pageInfo: AwardPageInfo }> = ({ pageInfo }) => {
    const { mobile } = useAppDisplayModeContext();

    const { css } = useStyles({ isMobile: mobile });

    const { awards } = useLoaderData<InfoPageLoaderData>().awardsResult;

    const [searchParams, setSearchParams] = useSearchParams();

    const loadMoreAwards = () => {
        setSearchParams(
            {
                ...searchParams,
                awardPage: ((pageInfo?.currentPage ?? 1) + 1).toString(),
            },
            {
                preventScrollReset: true,
            },
        );
    };

    if (mobile) {
        return (
            <div className={css(S.AwardWrapper)}>
                <Label variant={'01'} className={css(S.HeaderTitleMobile)}>
                    Awards and recognition
                </Label>

                <div className={css(S.AwardTable)}>
                    {awards.map((ta, i) =>
                        ta.AwardingInstitutionTitle && ta.YearAwarded ? (
                            <AwardRowFullMobile {...ta} key={i} />
                        ) : (
                            <AwardRowSingleMobile title={ta.Title} key={i} />
                        ),
                    )}
                </div>
                {pageInfo.hasNextPage && (
                    <Button
                        transparent={true}
                        size={18}
                        style={{
                            textDecoration: 'underline',
                            textUnderlineOffset: pxToRem(2),
                            display: 'block',
                            padding: pxToRem(7),
                        }}
                        variables={{
                            buttonPadding: pxToRem(25),
                        }}
                        fluid={true}
                        color={'primary'}
                        onClick={() => loadMoreAwards()}
                    >
                        View more
                    </Button>
                )}
            </div>
        );
    }

    return (
        <div className={css(S.AwardWrapper)}>
            <PageSection sectionTitle={'Awards and recognition'}>
                <div className={css(S.AwardTable)}>
                    {awards.map((ta, i) => (
                        <AwardRowFull {...ta} key={i} />
                    ))}
                </div>
                {pageInfo.hasNextPage && (
                    <Button
                        transparent={true}
                        variant="text"
                        size={18}
                        style={{
                            textDecoration: 'underline',
                            textUnderlineOffset: pxToRem(2),
                            display: 'block',
                            padding: pxToRem(7),
                        }}
                        variables={{
                            buttonPadding: 0,
                        }}
                        fluid={true}
                        color={'primary'}
                        onClick={() => loadMoreAwards()}
                    >
                        View more
                    </Button>
                )}
            </PageSection>
        </div>
    );
};
